import React from 'react';
import { connect } from 'react-redux';
import BaseComponent from '../../../../../baseClasses/BaseComponent';
import TabbedPageControl from '../../../../../components/TabbedPageControl';
import delaysTimelineIcon from '../../../../../assets/images/delays-timeline-icon.svg';
import workQualityTimelineIcon from '../../../../../assets/images/work-quality-timeline-icon.svg';
import workCompletionTimelineIcon from '../../../../../assets/images/work-completion-timeline-icon.svg';
import timelineIndicatorPoint from '../../../../../assets/images/timeline-indicator-point.svg';
import forwardArrowIcon from '../../../../../assets/images/arrow-button.svg';
import delayIcon from '../../../../../assets/images/delays-icon-active.svg';
import AnalyticsLogger from '../../../../../helpers/analytics/analyticsLogger';
import './ProjectActivityPopup.scss';

function getLocalDateTime(gmtDate) {
  const utcString = new Date(gmtDate).toUTCString();
  const myDate = new Date(utcString);
  return myDate;
}

function formatDate(date) {

  var tzName = date.toLocaleString('en', { timeZoneName: 'short' }).split(' ').pop();
  let hours = date.getHours();
  let ampm = 'AM';
  if (hours == 0) {
    hours = 12;
    ampm = 'AM';
  }
  if (hours > 12) {
    ampm = 'PM';
    hours -= 12;
  }
  let minutes = date.getMinutes();
  if (minutes < 10) {
    minutes = '0' + minutes;
  }
  const timeString = hours + ':' + minutes + ' ' + ampm + ' ' + tzName;
  const dateString = (date.getMonth() + 1) + '/' + date.getDate() + '/' + date.getFullYear();

  return timeString + ' ' + dateString;
}

export class ProjectActivityPopup extends BaseComponent {

  constructor(props) {
    super(props);

    this.state = {
      delaysCount: 0,
      workCompletionCount: 0,
      workQualityCount: 0,
    };
    this.tabs = ['categories', 'all activity'];
    this.analyticsLogger = new AnalyticsLogger({
      isMobile: !!window.cordova,
    });
  }
  
  componentDidMount() {
    super.componentDidMount();
    this.handleCategorizeEvents();
    this.ensureTabs(this.props, false);
    this.handleClickOutside = event => {
      if (this.componentRef &&
        !this.componentRef.contains(event.target)) {
        this.handleClosePopup();
      }
    };

    document.addEventListener('click', this.handleClickOutside, false);
  }

  componentWillUnmount() {
    document.removeEventListener('click', this.handleClickOutside, false);
  }

  handleCategorizeEvents() {
    const { bar } = this.props;
    if (bar.payload) {
      this.setState({
        delaysCount: bar.payload.delaysCount, workCompletionCount: bar.payload.workCompletionCount,
        workQualityCount: bar.payload.workQualityCount, totalCount: bar.payload.delaysCount + bar.payload.workCompletionCount +
          bar.payload.workQualityCount,
      });
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.filters != this.state.filters) {
      const { bar } = this.props;
      let events = bar.payload.actualEvents;
      if (this.state.filters) {
        const filteredEvents = events.filter(event => {
          return this.state.filters.includes(event.activity.name);
        });
  
        this.setState({ filteredCount: filteredEvents.length });
      }
    }
  }

  ensureTabs(props, isUpdate) {
    this.setState({
      selectedTabName: 'categories',
    });
  }

  handleTabClick(tabName) {
    if (tabName == 'categories') {
      this.tabs = ['categories', 'all activity'];
      this.setState({ filters: null, filteredCount: null });
    } else {
      this.analyticsLogger.logProjectEvent('ProjectActivityAllActivityViewed');
    }
    this.setState({ selectedTabName: tabName });
  }

  handleClosePopup(e) {
    this.props.closePopup();
  }

  handleMapActivies(event) {
    if (!event) {
      return 'Unknown Activity';
    }
    switch (event.activity.name) {
    case 'Delay Submitted':
      return event.activity_sub_type && event.activity_sub_type.name ? event.activity_sub_type.name + ' Delay' : 'Unspecified Delay';
    case 'Attachment Upload':
      return event.activity_sub_type && event.activity_sub_type.name ? event.activity_sub_type.name + ' Upload' : 'Photo Upload';
    case 'Completion Step is Completed':
      if (event.completion_criterion) {
        switch (event.completion_criterion.completion_type) {
        case 'boolean':
          return 'Checkoff Completed';
        case 'file_upload':
          return 'File Upload Completed';
        case 'inspection':
          return 'Inspection Completed';
        case 'form':
          return 'Form Fillout Completed';
        default:
          return 'Step Completed';
        }
      }
      break;
    case 'Inventory Added':
      return 'Inventory Added';
    case 'Rejected':
      return 'Rejected Completion Step';
    case 'Accepted':
      return 'Completion Step Accepted';
    default:
      return 'Unsupported Type: ' + event.activity_id;
    }
  }

  handleActivitySelection(event) {
    const { handleEventClickThrough } = this.props;
    if (handleEventClickThrough) {
      this.handleClosePopup();
      handleEventClickThrough(event);
    }
  }

  getActivities() {
    const { bar } = this.props;
    let events = bar.payload.actualEvents;
    if (!events || events.length == 0) {
      return <div className="no-results-found">No Results Found</div>;
    }
    events.sort((a1, a2) => {
      return getLocalDateTime(a1.created_at) > getLocalDateTime(a2.created_at) ? -1 : getLocalDateTime(a1.created_at) < getLocalDateTime(a2.created_at) ? 1 : 0;
    });

    let filteredEvents = events;
    if (this.state.filters) {
      filteredEvents = events.filter(event => {
        return this.state.filters.includes(event.activity.name);
      });
    }

    if (!filteredEvents || filteredEvents.length == 0) {
      return <div className="no-results-found-popup">No Results Found</div>;
    }

    return filteredEvents.map(event => {
      if (!event) {
        return null;
      }
      let activity = event.activity;
      let userImage = null;
      const user = event.user_who_performed_action;
      let profilePic = user ? user.profile_image : null;
  
      if (profilePic) {
        userImage = <img className="activity-icon rounded" alt="profile" src={profilePic} />;    }
      else {
        const names = user ? [user.first_name ? user.first_name : ' ', user.last_name ? user.last_name : ' '] : ['None', 'Available'];
        const initials = names.length == 0 ? '' : names[0].substr(0, 1).toUpperCase() +
          (names.length > 1 ? names[1].substr(0, 1).toUpperCase() : '');
        userImage = <div className="default-user-image-container">
          <div className="default-user-image" />
          <div className="user-initials">{initials}</div>
        </div>;
      }

      let typeOverlay = null;
      if (activity.name == 'Delay Submitted') {
        typeOverlay = <img className="delay-overlay" src={delayIcon} alt="delay"/>;
      }
      else if (activity.name == 'Rejected') {
        typeOverlay = <div className="rejected-overlay">Rejection</div>;
      }
  
      return <div className="popup-activity-entry" key={event.id} onClick={e => { this.handleActivitySelection(event); } }>
        {userImage}
        {typeOverlay}
        <div className="activity-type-name short">{this.handleMapActivies(event)}</div>
          <div className="activity-user-name">{activity.user_who_performed_action ? (event.user_who_performed_action.first_name + ' ' + event.user_who_performed_action.last_name) : ''}</div>
          <div className="activity-date">{formatDate(getLocalDateTime(event.created_at))}</div>
        <img className="click-through-arrow" alt="clickthrough" src={forwardArrowIcon}/>
        </div>;
    });
  }

  handleFilterToDelays(e) {
    e.stopPropagation();
    setTimeout(() => {
      this.tabs = ['categories', 'delays'];
      this.setState({ selectedTabName: 'delays', filters: ['Delay Submitted'] });
    }, 10);
  }

  handleFilterToWorkCompletion(e) {
    e.stopPropagation();
    setTimeout(() => {
      this.tabs = ['categories', 'completion'];
      this.setState({ selectedTabName: 'completion', filters: ['Attachment Upload', 'Inventory Added', 'Completion Step is Completed'] });
    }, 10);
  }

  handleFilterToWorkQuality(e) {
    e.stopPropagation();
    setTimeout(() => {
      this.tabs = ['categories', 'quality'];
      this.setState({ selectedTabName: 'quality', filters: ['Rejected', 'Accepted'] });
    }, 10);
  }

  render() {
    const { selectedTabName, totalCount, filteredCount, delaysCount, workCompletionCount, workQualityCount } = this.state;
    let tabbedView = null;

    let left = (this.props.bar.x ? this.props.bar.x + 268 : this.props.bar.clientX);
    let top = (window.innerHeight - 568) + this.props.bar.y + (this.props.bar.height / 2);
    let switched = false;
    if (left + 300 > window.innerWidth) {
      left -= 266;
      switched = true;
    }

    return (
      <div className="project-activity-popup" style={{ left: left, top: top }} ref={el => this.componentRef = el} >
        <div className="close-button" onClick={this.handleClosePopup}>X</div>
        <div className="popup-activity-title-line">
          <div className="popup-activity-title">Project Activity</div>
          <div className="popup-activity-count">{'(' + (filteredCount != undefined && filteredCount != null ? filteredCount : totalCount) + ')'}</div>
        </div>
        <div className="popup-activity-tabs-container">
          <TabbedPageControl
            tabItems={this.tabs}
            selectedTabName={selectedTabName}
            handleClick={this.handleTabClick}
          />
        </div>
        <div className="tabbed-view-container">
          {tabbedView}
        </div>
        {selectedTabName == 'categories' ? (
          < div className="popup-activity-entries categories">
          <div className="popup-activity-entry" onClick={this.handleFilterToDelays}>
          <img className={'activity-icon'} src={delaysTimelineIcon} alt="delays" />
            <div className="activity-type-name">{'DELAYS'}</div>
                <div className="activity-type-count">{'(' + delaysCount + ')'}</div>
                <img className="click-through-arrow" alt="clickthrough" src={forwardArrowIcon} />
            </div>
        <div className="popup-activity-entry" onClick={this.handleFilterToWorkCompletion}>
          <img className={'activity-icon'} src={workCompletionTimelineIcon} alt="work completion" />
            <div className="activity-type-name">{'WORK COMPLETION'}</div>
                <div className="activity-type-count">{'(' + workCompletionCount + ')'}</div>
                <img className="click-through-arrow" alt="clickthrough" src={forwardArrowIcon} />
            </div>
        <div className="popup-activity-entry" onClick={this.handleFilterToWorkQuality}>
              <img className={'activity-icon'} src={workQualityTimelineIcon} alt="work quality" />
          <div className="activity-type-name">{'WORK QUALITY'}</div>
                <div className="activity-type-count">{'(' + workQualityCount + ')'}</div>
                <img className="click-through-arrow" alt="clickthrough" src={forwardArrowIcon} />
            </div>
          </div>) :
          (<div className="popup-activity-entries">
            {this.getActivities()}
          </div>)
  }
        <img className={'timeline-indicator-point' + (switched? ' switched': '')} src={timelineIndicatorPoint} alt="point" />
        <div className={'timeline-indicator-point-fixup' + (switched ? ' switched': '')}/>
        </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
  };
};

export default connect(mapStateToProps)(ProjectActivityPopup);



// WEBPACK FOOTER //
// ./src/containers/ProjectsContainer/ProjectHierarchy/ProjectTimeline/ProjectActivityPopup/index.js